import {
  AnalyticsCountryUsersItem,
  AnalyticsDimensionActivityItem,
  AnalyticsPeriod,
  AnalyticsReportUsageItem,
  AnalyticsSummary,
  AnalyticsUserActivityItem,
} from '../../services/AnalyticsApi';
import { HttpRequestError } from '../../types';
import {
  ActionType,
  FindAnalyticsCountriesSuccessAction,
  FindAnalyticsCountriesUsersSuccessAction,
  FindAnalyticsCountryReportsSuccessAction,
  FindAnalyticsCountryRolesSuccessAction,
  FindAnalyticsFailureAction,
  FindAnalyticsRequestedAction,
  FindAnalyticsRolesSuccessAction,
  FindAnalyticsRoleReportsSuccessAction,
  FindAnalyticsSummarySuccessAction,
  FindAnalyticsTopSuccessAction,
  FindAnalyticsUsageSuccessAction,
  FindAnalyticsUsersSuccessAction,
} from './types';

export const findAnalyticsRequested = (period?: AnalyticsPeriod): FindAnalyticsRequestedAction => ({
  type: ActionType.findAnalyticsRequested,
  period,
});

export const findAnalyticsSummarySuccess = (
  summary: AnalyticsSummary
): FindAnalyticsSummarySuccessAction => ({
  type: ActionType.findAnalyticsSummarySuccess,
  summary,
});

export const findAnalyticsUsageSuccess = (
  reportsUsage: AnalyticsReportUsageItem[]
): FindAnalyticsUsageSuccessAction => ({
  type: ActionType.findAnalyticsUsageSuccess,
  reportsUsage,
});

export const findAnalyticsTopSuccess = (
  reportsTop: AnalyticsReportUsageItem[]
): FindAnalyticsTopSuccessAction => ({
  type: ActionType.findAnalyticsTopSuccess,
  reportsTop,
});

export const findAnalyticsUsersSuccess = (
  usersActivity: AnalyticsUserActivityItem[]
): FindAnalyticsUsersSuccessAction => ({
  type: ActionType.findAnalyticsUsersSuccess,
  usersActivity,
});

export const findAnalyticsCountriesSuccess = (
  countriesActivity: AnalyticsDimensionActivityItem[]
): FindAnalyticsCountriesSuccessAction => ({
  type: ActionType.findAnalyticsCountriesSuccess,
  countriesActivity,
});

export const findAnalyticsRolesSuccess = (
  rolesActivity: AnalyticsDimensionActivityItem[]
): FindAnalyticsRolesSuccessAction => ({
  type: ActionType.findAnalyticsRolesSuccess,
  rolesActivity,
});

export const findAnalyticsCountriesUsersSuccess = (
  countriesUsers: AnalyticsCountryUsersItem[]
): FindAnalyticsCountriesUsersSuccessAction => ({
  type: ActionType.findAnalyticsCountriesUsersSuccess,
  countriesUsers,
});

export const findAnalyticsCountryReportsSuccess = (
  countryReportsActivity: AnalyticsDimensionActivityItem[]
): FindAnalyticsCountryReportsSuccessAction => ({
  type: ActionType.findAnalyticsCountryReportsSuccess,
  countryReportsActivity,
});

export const findAnalyticsRoleReportsSuccess = (
  roleReportsActivity: AnalyticsDimensionActivityItem[]
): FindAnalyticsRoleReportsSuccessAction => ({
  type: ActionType.findAnalyticsRoleReportsSuccess,
  roleReportsActivity,
});

export const findAnalyticsCountryRolesSuccess = (
  countryRolesActivity: AnalyticsDimensionActivityItem[]
): FindAnalyticsCountryRolesSuccessAction => ({
  type: ActionType.findAnalyticsCountryRolesSuccess,
  countryRolesActivity,
});

export const findAnalyticsFailure = (error: HttpRequestError): FindAnalyticsFailureAction => ({
  type: ActionType.findAnalyticsFailure,
  error,
});
